import { render, staticRenderFns } from "./KasaObracun.vue?vue&type=template&id=1981375e&scoped=true"
import script from "./KasaObracun.vue?vue&type=script&lang=js"
export * from "./KasaObracun.vue?vue&type=script&lang=js"
import style0 from "./KasaObracun.vue?vue&type=style&index=0&id=1981375e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981375e",
  null
  
)

export default component.exports